import axios from 'axios';

function appendCrop(formData, { originalFile, croppedFile, croppedArea, aspectRatio, cropShape, rotation }) {
  formData.append('croppedAreaPixels', JSON.stringify(croppedArea ?? {}));
  formData.append('aspectRatio', String(aspectRatio ?? 1));
  formData.append('cropShape', cropShape ?? 'rect');
  formData.append('rotation', String(rotation ?? 0));
  if (originalFile) {
    formData.append('originalFile', originalFile);
  }
  formData.append('croppedFile', croppedFile);
  return formData;
}

export async function createMachineContentPhoto(machineContentId, prepared, { title, sortOrder } = {}) {
  const formData = new FormData();
  formData.append('machineContentId', machineContentId);
  formData.append('title', title || prepared.croppedFile?.name || 'Photo');
  if (sortOrder != null) {
    formData.append('sort_order', String(sortOrder));
  }
  appendCrop(formData, prepared);
  return axios.post('machine-content-photo', formData);
}

export async function updateMachineContentPhotoImage(photoId, prepared) {
  return axios.post(`machine-content-photo/${photoId}/image`, appendCrop(new FormData(), prepared));
}

export async function deleteMachineContentPhoto(photoId) {
  return axios.delete(`machine-content-photo/${photoId}`);
}

export async function fetchMachineContentPhotoSource(photo) {
  const photoId = typeof photo === 'string' ? photo : photo?.id;
  if (!photoId) {
    return null;
  }
  const { data } = await axios.get(`machine-content-photo/${photoId}/source`, {
    responseType: 'blob',
    skipConnectivityGuard: true,
  });
  if (!(data instanceof Blob) || data.type?.includes('text/html')) {
    return null;
  }
  return URL.createObjectURL(data);
}

export const MACHINE_CONTENT_PHOTO_API = {
  create: createMachineContentPhoto,
  updateImage: updateMachineContentPhotoImage,
  remove: deleteMachineContentPhoto,
  fetchSource: fetchMachineContentPhotoSource,
};
